module.exports = __webpack_public_path__ + "img/avchd.bace9f96.svg";